import { setTerm } from './helpers';

export const setNotLastFloor = setTerm('not_last_floor');
